import { uppTemplatesPerScenarioConfig } from '#src/clientState/providers/DynamicTemplateProvider/UPPtemplateConfigPerScenario';
import { getOptionalParamFromKey } from '#src/utils';
import { DEFAULT_SCENARIO_ID } from '#src/utils/constants';
import { useRouter } from '@edreamsodigeo/frontend-core';
import { useMemo } from 'react';

export const SCENARIO_ID_PARAM_KEY = 'scenarioId';

const getScenarioIdFromUrlParam = (optionalParams): string | undefined => {
  const paramValue = getOptionalParamFromKey(
    optionalParams,
    SCENARIO_ID_PARAM_KEY
  );
  return paramValue &&
    Object.prototype.hasOwnProperty.call(
      uppTemplatesPerScenarioConfig,
      paramValue
    )
    ? paramValue
    : undefined;
};

export const useScenarioIdFromUrl = (): string => {
  const { query } = useRouter();
  const optionalParams = query?.params || [];
  const scenarioId = getScenarioIdFromUrlParam(optionalParams) as string;
  return useMemo(() => scenarioId ?? DEFAULT_SCENARIO_ID, [scenarioId]);
};
